export default __webpack_public_path__ + "static/media/change_password.093202c2.svg";